import { get, post, put, del } from 'services/client';
import { apiEndpoints } from 'config';

export default {
  getWineLists: async params => {
    const options = { url: apiEndpoints.menus, params: { ...params } };
    return get(options);
  },
  getWineList: async id => {
    const options = { url: apiEndpoints.menu.replace(':id', id) };
    return get(options);
  },
  createWineList: async data => {
    const options = { url: apiEndpoints.menus, data };
    return post(options);
  },
  updateWineList: async (data, id) => {
    const options = { url: apiEndpoints.menu.replace(':id', id), data };
    return put(options);
  },
  deleteWineListMany: async data => {
    const options = { url: apiEndpoints.menus, data };
    return del(options);
  },
  getQRCode: async id => {
    const options = { url: apiEndpoints.menuQRCode.replace(':id', id) };
    return get(options);
  },
  updateQRCode: async (data, id) => {
    const options = {
      url: apiEndpoints.menuQRCode.replace(':id', id),
      data,
    };
    return put(options);
  },
  getDefaultsCount: async id => {
    const options = { url: apiEndpoints.defaultsCount.replace(':id', id) };
    return get(options);
  },
};
